export default __webpack_public_path__ + "static/media/furniture14.16cb929c.jpeg";